function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0H24V24H0V0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.23 15.26L16.69 14.97A1.99 1.99 0 0 0 15.05 15.54L13.21 17.38A15.045 15.045 0 0 1 6.62 10.79L8.47 8.94C8.9 8.51 9.11 7.91 9.04 7.3L8.75 4.78A2.001 2.001 0 0 0 6.76 3.01H5.03C3.9 3.01 2.96 3.95 3.03 5.08 3.56 13.62 10.39 20.44 18.92 20.97 20.05 21.04 20.99 20.1 20.99 18.97V17.24C21 16.23 20.24 15.38 19.23 15.26z"
});

var SvgRoundPhone24px = function SvgRoundPhone24px(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPlBob25lPC90aXRsZT48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNMTkuMjMgMTUuMjZsLTIuNTQtLjI5Yy0uNjEtLjA3LTEuMjEuMTQtMS42NC41N2wtMS44NCAxLjg0Yy0yLjgzLTEuNDQtNS4xNS0zLjc1LTYuNTktNi41OWwxLjg1LTEuODVjLjQzLS40My42NC0xLjAzLjU3LTEuNjRsLS4yOS0yLjUyYy0uMTItMS4wMS0uOTctMS43Ny0xLjk5LTEuNzdINS4wM2MtMS4xMyAwLTIuMDcuOTQtMiAyLjA3LjUzIDguNTQgNy4zNiAxNS4zNiAxNS44OSAxNS44OSAxLjEzLjA3IDIuMDctLjg3IDIuMDctMnYtMS43M2MuMDEtMS4wMS0uNzUtMS44Ni0xLjc2LTEuOTh6Ii8+PC9zdmc+';
export { SvgRoundPhone24px as ReactComponent };